import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { TicketHistoryService } from '../../search-result/services/ticket-history.service';
import { SearchForm } from 'src/app/core/models/itinerary.model';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

@Injectable()
export class TicketHistoryGuard implements CanActivate {
  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private ticketHistoryService: TicketHistoryService,
    private layoutService: LayoutService
  ) {}

  loadTicketHistory(form: SearchForm) {
    return this.api.getTicketHistory(form).pipe(
      map(response => {
        this.layoutService.dispatchChangeBreadcrumb(form.pnr, OptionType.TicketHistory);
        this.ticketHistoryService.dispatchLoadTicketHistorySuccess(response);
        return !!response;
      }),
      catchError(response => {
        this.itineraryService.dispatchGenericError(response);
        this.itineraryService.navigateToWithParams('itinerary/info');
        return of(false);
      })
    );
  }
  
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.loadTicketHistory({...route.queryParams} as SearchForm);
  }
}
